import pure from "./higher-order/pure";
import React from "react";

export default pure(({ currentUserId, ticket, user }) => { // eslint-disable-line no-unused-vars
  return (<ul className="leaderboard_meta" />);
  /* FIXME: disabled for now, since there's no backend support
  var socialLink = <a className="leaderboard_social dw-thumb_up"></a>;
  if (currentUserId === ticket.get("user_id")) {
    socialLink = <a className="leaderboard_social dw-share"></a>;
  }
  return (
    <ul className="leaderboard_meta">
      <li>Level {user.get("level")}</li>
      <li>
        {socialLink}
      </li>
    </ul>
  );
  */
});
